module.exports = __webpack_public_path__ + "img/1449946829.feea0fe5.jpg";